export default "__VITE_ASSET__$m_q5Z$V__"